import { getIn18Text } from 'api';
const htmlErrmsg = new Map();
const notSupport = [102, 104, 105, 106, 107, 109, 110, 114, 116, 202, 205, 11, 14];
const textLong = [103, 12];
const retry = [108, 111, 112, 201, 203, 206, 207, 301, 302, 303, 304, 401, 402, 405, 30];
const noContext = [101, 113];
const visitRepeat = [411];
const longRepeat = [412];
notSupport.forEach(n => {
    htmlErrmsg.set(n, getIn18Text('BUZHICHIGAILEI11'));
});
textLong.forEach(n => {
    htmlErrmsg.set(n, getIn18Text('FANYISHIBAI\uFF0C11'));
});
retry.forEach(n => {
    htmlErrmsg.set(n, getIn18Text('FANYISHIBAI\uFF0C'));
});
noContext.forEach(n => {
    htmlErrmsg.set(n, getIn18Text('FANYINEIRONGBU'));
});
visitRepeat.forEach(n => {
    htmlErrmsg.set(n, getIn18Text('FANGWENPINLVGUO'));
});
longRepeat.forEach(n => {
    htmlErrmsg.set(n, getIn18Text('CHANGQINGQIUGUOYU'));
});
htmlErrmsg.set(500, {
    '11': getIn18Text('BUZHICHIGAILEI11'),
    '12': getIn18Text('FANYISHIBAI\uFF0C11'),
    '14': getIn18Text('BUZHICHIDEFAN'),
    '30': getIn18Text('FANYISHIBAI\uFF0C'),
});
const translateLangMap = {
    'zh-CHS': getIn18Text('JIANTIZHONGWEN'),
    en: getIn18Text('YINGWEN'),
    ja: getIn18Text('RIWEN'),
    ko: getIn18Text('HANWEN'),
};
const supportDetectLang = [
    { label: '阿拉伯语', value: 'ar' },
    { label: '德语', value: 'de' },
    { label: '英语', value: 'en' },
    { label: '西班牙语', value: 'es' },
    { label: '法语', value: 'fr' },
    { label: '印度尼西亚语', value: 'id' },
    { label: '意大利语', value: 'it' },
    { label: '日语', value: 'ja' },
    { label: '韩语', value: 'ko' },
    { label: '荷兰语', value: 'nl' },
    { label: '葡萄牙语', value: 'pt' },
    { label: '俄语', value: 'ru' },
    { label: '泰语', value: 'th' },
    { label: '越南语', value: 'vi' },
    { label: '简体中文', value: 'zh-CHS' },
    { label: '繁体中文', value: 'zh-CHT' },
];
const isSupportOriginLang = (lang) => {
    return supportDetectLang.some(item => item.value.includes(lang));
};
const getTranslateErrorMsg = (code, message) => {
    let errorMessage = '';
    if (code === 500 && message) {
        const errorIn500 = htmlErrmsg.get(500);
        errorMessage = errorIn500[message];
    }
    else if (code && code !== 500) {
        errorMessage = htmlErrmsg.get(code);
    }
    errorMessage = errorMessage || message || getIn18Text('FANYISHIBAI\uFF0C');
    return errorMessage;
};
export { translateLangMap, isSupportOriginLang, supportDetectLang, htmlErrmsg, getTranslateErrorMsg };
